<template>
  <div class="basic">
    <van-collapse v-model="activeNames">
      <van-collapse-item class="box" title="组织信息" name="1" :border="false">
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="basicEmployeeInfo.empno"
            label="工号"
            readonly
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="orgInfo.orgid"
            label="部门"
            readonly
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="orgInfo.postid"
            label="岗位名称"
            readonly
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="orgInfo.emprank"
            label="职级"
            readonly
          />
        </van-cell-group>
        <!-- <van-cell-group>
          <van-field
            input-align="right"
            v-model="orgInfo.emprank1"
            label="职衔"
            readonly
          />
        </van-cell-group> -->
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="orgInfo.parentid"
            label="直属上司"
            readonly
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="orgInfo.posttype"
            label="岗位类型"
            readonly
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            type="textarea"
            autosize
            rows="1"
            input-align="right"
            v-model="orgInfo.orgpath"
            label="组织路径"
            readonly
          />
        </van-cell-group>
      </van-collapse-item>
      <van-collapse-item title="基本信息" name="2">
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="basicEmployeeInfo.title"
            label="姓名"
            readonly
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="basicEmployeeInfo.emptype"
            label="人员类别"
            readonly
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="basicEmployeeInfo.mobileno"
            label="联系电话"
            :readonly="basicEmployeeInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-if="basicEmployeeInfo.readonly === true"
            v-model="basicEmployeeInfo.maritalstatus"
            label="婚姻状况"
            :readonly="basicEmployeeInfo.readonly"
          />
          <van-field
            input-align="right"
            v-else
            readonly
            clickable
            :value="basicEmployeeInfo.maritalstatus"
            label="婚姻状况"
            @click="(showMaritalstatus = true), getDict('MaritalStatus')"
          />
          <van-popup v-model="showMaritalstatus" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConMaritalstatus"
              @cancel="showMaritalstatus = false"
            />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="basicEmployeeInfo.idno"
            label="证件号码"
            :readonly="basicEmployeeInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-if="basicEmployeeInfo.readonly === true"
            v-model="basicEmployeeInfo.idtype"
            label="证件类型"
            :readonly="basicEmployeeInfo.readonly"
          />
          <van-field
            input-align="right"
            v-else
            readonly
            clickable
            :value="basicEmployeeInfo.idtype"
            label="证件类型"
            @click="(showIdType = true), getDict('idType')"
          />
          <van-popup v-model="showIdType" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConIdType"
              @cancel="showIdType = false"
            />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-if="basicEmployeeInfo.readonly === true"
            v-model="basicEmployeeInfo.idenddate"
            label="证件有效期"
            :readonly="basicEmployeeInfo.readonly"
          />
          <van-field
            input-align="right"
            type="date"
            v-else
            v-model="basicEmployeeInfo.idenddate"
            label="证件有效期"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="basicEmployeeInfo.idaddress"
            label="签发机关"
            :readonly="basicEmployeeInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="basicEmployeeInfo.age"
            label="年龄"
            :readonly="basicEmployeeInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="basicEmployeeInfo.nativeplace"
            label="籍贯"
            :readonly="basicEmployeeInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-if="basicEmployeeInfo.readonly === true"
            v-model="basicEmployeeInfo.gender"
            label="性别"
            :readonly="basicEmployeeInfo.readonly"
          />
          <van-field
            input-align="right"
            v-else
            readonly
            clickable
            :value="basicEmployeeInfo.gender"
            label="性别"
            @click="(showGender = true), getDict('gender')"
          />
          <van-popup v-model="showGender" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConGender"
              @cancel="showGender = false"
            />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-if="basicEmployeeInfo.readonly === true"
            v-model="basicEmployeeInfo.nation"
            label="民族"
            :readonly="basicEmployeeInfo.readonly"
          />
          <van-field
            input-align="right"
            v-else
            readonly
            clickable
            :value="basicEmployeeInfo.nation"
            label="民族"
            @click="(showNation = true), getDict('nation')"
          />
          <van-popup v-model="showNation" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConNation"
              @cancel="showNation = false"
            />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-if="basicEmployeeInfo.readonly === true"
            v-model="basicEmployeeInfo.householdregister"
            label="户籍"
            :readonly="basicEmployeeInfo.readonly"
          />
          <van-field
            input-align="right"
            v-else
            readonly
            clickable
            :value="basicEmployeeInfo.householdregister"
            label="户籍"
            @click="
              (showHouseholdregister = true), getDict('householdregister')
            "
          />
          <van-popup v-model="showHouseholdregister" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConHouseholdregister"
              @cancel="showHouseholdregister = false"
            />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-if="basicEmployeeInfo.readonly === true"
            v-model="basicEmployeeInfo.party"
            label="政治面貌"
            :readonly="basicEmployeeInfo.readonly"
          />
          <van-field
            input-align="right"
            v-else
            readonly
            clickable
            :value="basicEmployeeInfo.party"
            label="政治面貌"
            @click="(showParty = true), getDict('party')"
          />
          <van-popup v-model="showParty" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConParty"
              @cancel="showParty = false"
            />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field
            type="textarea"
            autosize
            rows="1"
            input-align="right"
            v-model="basicEmployeeInfo.permanentaddress"
            label="户籍地址"
            :readonly="basicEmployeeInfo.readonly"
          />
        </van-cell-group>
        <!-- <van-cell-group>
          <div class="edit">
            <van-button
              round
              class="btn"
              @click="setInfoRead"
              v-if="basicEmployeeInfo.readonly === true"
              ><van-icon
                name="edit"
                style="margin-right: 6px"
              />修改</van-button
            >
          </div>
          <div class="add">
            <van-button
              round
              class="btnTwo"
              @click="setInfoReset"
              v-if="basicEmployeeInfo.readonly === false"
              >取消</van-button
            >
            <van-button
              round
              class="btnTwo"
              type="info"
              @click="setInfoQuery"
              v-if="basicEmployeeInfo.readonly === false"
              >确定</van-button
            >
          </div>
        </van-cell-group> -->
      </van-collapse-item>
      <van-collapse-item title="合同信息" name="3">
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.conunit"
            label="签约单位"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.contype"
            label="合同类型"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.conproperty"
            label="合同属性"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.createdate"
            label="入职日期"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.comyear"
            label="司龄"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.probdate"
            label="转正日期"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            label-width="100"
            v-model="contractInfo.conbegindate"
            label="合同开始时间"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            label-width="100"
            v-model="contractInfo.conenddate"
            label="合同结束时间"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.conterm"
            label="合同期(月)"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            label-width="100"
            v-model="contractInfo.concount"
            label="合同签约次数"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.probterm"
            label="试用期"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            input-align="right"
            v-model="contractInfo.probenddate"
            label="拟转正日期"
            :readonly="contractInfo.readonly"
          />
        </van-cell-group>
      </van-collapse-item>
      <van-collapse-item title="通讯信息" name="4">
        <van-collapse-item
          class="conTitle"
          v-for="item in euBGEMInfoList"
          :title="item.emcontact"
          :key="item.id"
        >
          <!-- <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.empid"
              label="员工ID"
              :readonly="item.readonly"
            />
          </van-cell-group> -->
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.empno"
              label="员工工号"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.emcontact"
              label="紧急联系人"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              v-if="item.readonly === true"
              label-width="120"
              v-model="item.emcontactrel"
              label="紧急联系人关系"
              :readonly="item.readonly"
            />
            <van-field
              input-align="right"
              v-else
              readonly
              clickable
              label-width="120"
              :value="item.emcontactrel"
              label="紧急联系人关系"
              @click="(showEmcontactrel = true), getDict('emcontactrel')"
            />
            <van-popup v-model="showEmcontactrel" position="bottom">
              <van-picker
                show-toolbar
                :columns="columns"
                @confirm="onConEmcontactrel"
                @cancel="showEmcontactrel = false"
              />
            </van-popup>
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.emcontacttel"
              label="电话"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <van-cell-group>
            <van-field
              input-align="right"
              label-width="100"
              v-model="item.remark"
              label="备注"
              :readonly="item.readonly"
            />
          </van-cell-group>
          <!-- <van-cell-group>
            <div class="edit">
              <van-button
                round
                class="btn"
                @click="setCommunRead(item.id)"
                v-if="item.readonly === true"
                ><van-icon
                  name="edit"
                  style="margin-right: 6px"
                />修改</van-button
              >
            </div>
            <div class="add">
              <van-button
                round
                class="btnTwo"
                @click="setCommunReset(item.id)"
                v-if="item.readonly === false"
                >取消</van-button
              >
              <van-button
                round
                class="btnTwo"
                type="info"
                @click="setCommunQuery(item.id)"
                v-if="item.readonly === false"
                >确定</van-button
              >
            </div>
          </van-cell-group> -->
        </van-collapse-item>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis";
import utils from "@/utils/utils";
import { getToken } from "@/utils/cookie";
// import { onUpdated } from 'vue';
export default {
  name: "basic",
  data() {
    return {
      activeNames: ["1"],
      tagList: [],
      //组织信息
      orgInfo: {},
      //基本信息
      basicEmployeeInfo: {},
      basicEmployeeInfoData: {},
      //合同信息
      contractInfo: {},
      //通讯信息
      euBGEMInfoList: [],
      euBGEMInfoListData: {},
      showParty: false,
      showMaritalstatus: false,
      showIdType: false,
      showGender: false,
      showNation: false,
      showHouseholdregister: false,
      showEmcontactrel: false,
      columns: [],
      itemId: [],

      id: {
        idParty: "",
        idMaritalstatus: "",
        idType: "",
        idGender: "",
        idNation: "",
        idHouseholdregister: "",
        idEmcontactrel: "",
      },
      diffData: {},
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    //获取下拉框列表
    getDict(type) {
      api.setGetDicts({ type }).then((data) => {
        this.itemId = data.data;
        let items = data.data;
        this.columns = [];
        items.forEach((item) => {
          this.columns.push(item.title);
        });
      });
    },
    //确认政治面貌
    onConParty(value) {
      const str = this.itemId.find((item) => {
        return item.title === value;
      });
      this.id.idParty = str.id;
      this.basicEmployeeInfo.party = value;
      this.showParty = false;
    },
    //确认婚姻状况
    onConMaritalstatus(value) {
      const str = this.itemId.find((item) => {
        return item.title === value;
      });
      this.id.idMaritalstatus = str.id;
      this.basicEmployeeInfo.maritalstatus = value;
      this.showMaritalstatus = false;
    },
    //确认证件类型
    onConIdType(value) {
      const str = this.itemId.find((item) => {
        return item.title === value;
      });
      this.id.idType = str.id;
      this.basicEmployeeInfo.idtype = value;
      this.showIdType = false;
    },
    //确认性别
    onConGender(value) {
      const str = this.itemId.find((item) => {
        return item.title === value;
      });
      this.id.idGender = str.id;
      this.basicEmployeeInfo.gender = value;
      this.showGender = false;
    },
    //确认民族
    onConNation(value) {
      const str = this.itemId.find((item) => {
        return item.title === value;
      });
      this.id.idNation = str.id;
      this.basicEmployeeInfo.nation = value;
      this.showNation = false;
    },
    //确认户籍
    onConHouseholdregister(value) {
      const str = this.itemId.find((item) => {
        return item.title === value;
      });
      this.id.idHouseholdregister = str.id;
      this.basicEmployeeInfo.householdregister = value;
      this.showHouseholdregister = false;
    },
    //确认紧急联系人关系
    onConEmcontactrel(value) {
      const str = this.itemId.find((item) => {
        return item.title === value;
      });
      this.id.idEmcontactrel = str.id;
      this.euBGEMInfoList.forEach((item) => {
        item.emcontactrel = value;
      });
      this.showEmcontactrel = false;
    },
    saveList(obj) {
      api.setSaveEmpInfo(obj).then(() => {
        this.getList();
      });
    },
    //修改
    setInfoRead() {
      this.basicEmployeeInfo.readonly = false;
    },
    //取消
    setInfoReset() {
      this.basicEmployeeInfo.readonly = true;
      this.getList();
    },
    //确定
    setInfoQuery() {
      utils.getDiffData(
        this.basicEmployeeInfoData,
        this.basicEmployeeInfo,
        this.diffData
      );
      this.basicEmployeeInfo.readonly = true;
      if (this.id.idMaritalstatus)
        this.diffData.maritalstatus = this.id.idMaritalstatus;
      if (this.id.idParty) this.diffData.party = this.id.idParty;
      if (this.id.idType) this.diffData.idtype = this.id.idType;
      if (this.id.idGender) this.diffData.gender = this.id.idGender;
      if (this.id.idNation) this.diffData.nation = this.id.idNation;
      if (this.id.idHouseholdregister)
        this.diffData.householdregister = this.id.idHouseholdregister;
      let obj = {
        ...this.diffData,
        table: "basicEmployeeInfo",
        saveType: "2",
        readonly: true,
        empno: this.basicEmployeeInfo.empno,
      };
      this.saveList(obj);
      this.diffData = {};
    },
    //点击修改
    setCommunRead(id) {
      const index = this.euBGEMInfoList.find((item) => {
        return item.id === id;
      });
      index.readonly = false;
      this.euBGEMInfoListData = { ...index };
    },
    //点击取消
    setCommunReset(id) {
      const index = this.euBGEMInfoList.find((item) => {
        return item.id === id;
      });
      index.readonly = true;
      this.getList();
    },
    //点击确定
    setCommunQuery(id) {
      const index = this.euBGEMInfoList.find((item) => {
        return item.id === id;
      });
      index.readonly = true;
      utils.getDiffData(this.euBGEMInfoListData, index, this.diffData);
      if (this.id.idEmcontactrel)
        this.diffData.emcontactrel = this.id.idEmcontactrel;
      let obj = {
        ...this.diffData,
        table: "euBGEMInfoList",
        saveType: "2",
        readonly: true,
        id: index.id,
        empno: index.empno,
        empid: index.empid,
      };
      this.saveList(obj);
      this.diffData = {};
    },

    //获取数据详情
    getList() {
      api.getSelectByEmpNo({ empNo: getToken() }).then((data) => {
        this.tagList = data.data;
        this.orgInfo = this.tagList.orgInfo;
        this.basicEmployeeInfo = this.tagList.basicEmployeeInfo;
        this.basicEmployeeInfoData = { ...this.tagList.basicEmployeeInfo };
        this.contractInfo = this.tagList.contractInfo;
        this.euBGEMInfoList = this.tagList.euBGEMInfoList;

        this.basicEmployeeInfo.idenddate =
          this.basicEmployeeInfo.idenddate &&
          moment(this.basicEmployeeInfo.idenddate).format("YYYY-MM-DD");
        this.contractInfo.conbegindate =
          this.contractInfo.conbegindate &&
          moment(this.contractInfo.conbegindate).format("YYYY-MM-DD");
        this.contractInfo.conenddate =
          this.contractInfo.conenddate &&
          moment(this.contractInfo.conenddate).format("YYYY-MM-DD");
        this.contractInfo.createdate =
          this.contractInfo.createdate &&
          moment(this.contractInfo.createdate).format("YYYY-MM-DD");
        this.contractInfo.probdate =
          this.contractInfo.probdate &&
          moment(this.contractInfo.probdate).format("YYYY-MM-DD");
        this.contractInfo.probenddate =
          this.contractInfo.probenddate &&
          moment(this.contractInfo.probenddate).format("YYYY-MM-DD");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.basic {
  ::v-deep .van-picker__toolbar {
    height: 40px * $zoom;
    .van-picker__cancel {
      font-size: 0.42667rem;
    }
    .van-picker__confirm {
      font-size: 16px * $zoom;
    }
  }
  ::v-deep .van-ellipsis {
    font-size: 8px * $zoom;
  }
  .van-collapse-item {
    margin-top: 5px * $zoom;
    background: none;
  }
  ::v-deep .van-cell__title span {
    font-size: 12px * $zoom;
    border-left: 6px solid #018755;
    padding-left: 15px;
  }
  ::v-deep .van-field {
    span {
      font-size: 10px * $zoom;
      border: none;
      padding-left: 0;
    }
  }
  ::v-deep .van-cell {
    display: flex;
    justify-content: space-between;
    border-radius: 15px;
  }
  ::v-deep van-collapse-item__title {
    .van-cell__title span {
      font-size: 20px * $zoom !important;
    }
  }
  ::v-deep .van-collapse-item__content {
    background: none;
    padding: 12px 0 0 0;
  }
  .conTitle {
    background: #fff;
    border-radius: 2px * $zoom;
    ::v-deep .van-cell__title span {
      font-size: 10px * $zoom;
      border: none;
      padding-left: 0;
    }
  }
}
.edit {
  width: 100%;
  display: flex;
  justify-content: center;
}
.btn {
  font-size: 12pt;
  padding: 10px * $zoom 40px * $zoom;
  margin: 10px * $zoom 0;
}
.add {
  width: 100%;
  display: flex;
  justify-content: center;

  .van-button__content {
    width: 80pt;
  }
}
.btnTwo {
  font-size: 12pt;
  // padding: 10px * $zoom 40px * $zoom;
  margin: 10px * $zoom 10px;
}
</style>
